import React from "react";
import { useI18n } from "@/lib/i18n/i18n_provider";

interface DailyBookableHoursMessageProps {
  bookableStartTime: string;
  bookableEndTime: string;
}

export const DailyBookableHoursMessage: React.FC<DailyBookableHoursMessageProps> =
  ({ bookableStartTime, bookableEndTime }) => {
    const { fbt } = useI18n();

    return (
      <div
        className="small mt-3 text-center"
        data-testid="daily-bookable-hours-message"
      >
        {fbt(
          "Daily rate includes " +
            fbt.param("bookable_start_time", bookableStartTime) +
            " - " +
            fbt.param("bookable_end_time", bookableEndTime) +
            " access"
        )}
      </div>
    );
  };
